export default {
  methods: {
    getCommonIconProps() {
      return (classes, condition) => ({
        size: '1.125rem',
        class: classes,
        color: condition ? 'red' : 'white'
      })
    },

    getCommonInputProps() {
      return modelName => ({
        color: 'white',
        dark: true,
        'no-error-icon': true,
        dense: true,
        error: this.$v[modelName].$error,
        'error-message': this.$v_displayMessage(this.$v[modelName])
      })
    }
  }
}
